import React                        from "react";
import { Navigate, useLocation }    from "react-router-dom";
import AuthService                  from "./service/AuthService";

const PrivateRoute = ({ children, roles }) => {
    const location = useLocation();
    const currentUser = AuthService.getCurrentUser();

    //idTokenClaims per la login con microsoft
    const userRoles = currentUser?.roles || currentUser?.idTokenClaims?.roles || [];
    const hasRole = userRoles.some((role) => roles.includes(role));

    if (!currentUser || !hasRole) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};

export default PrivateRoute;
